export enum AlertThresholdTypes {
	DELTA = 'DELTA',
	PERCENT = 'PERCENT',
	SIGNIFICANCE = 'SIGNIFICANCE'
}